import { lazy } from 'react';
import { Wrench } from 'lucide-react';
import type { FeatureSection } from '@/app/registry';

export const mechSection: FeatureSection = {
  key: 'veomech',
  title: 'veomech',
  icon: Wrench,
  routes: [
    {
      path: '/veomech/users',
      title: 'mechanics',
      resource: ['mech', 'platform'],
      component: lazy(() => import('./users/UsersPage')),
    },
    {
      path: '/veomech/assets',
      title: 'assets',
      resource: ['inventory.asset', 'platform'],
      component: lazy(() => import('./assets/AssetsPage')),
    },
    {
      path: '/veomech/models',
      title: 'models',
      resource: ['inventory.model', 'platform'],
      component: lazy(() => import('./assets/ModelsPage')),
    },
    {
      path: '/veomech/work-orders',
      title: 'workOrders',
      resource: ['work_order', 'platform'],
      component: lazy(() => import('./WorkOrdersPage')),
    },
    {
      path: '/veomech/inventory',
      title: 'localInventory',
      resource: ['inventory.part', 'platform'],
      component: lazy(() => import('./inventory/InventoryPage')),
    },
    {
      path: '/veomech/tasks',
      title: 'tasks',
      resource: ['work_order', 'platform'],
      component: lazy(() => import('./catalog/TasksPage')),
    },
    {
      path: '/veomech/catalog',
      title: 'partCatalog',
      resource: ['inventory.part.spec', 'platform'],
      component: lazy(() => import('./catalog/CataloguePage')),
    },
    {
      path: '/veomech/quality',
      title: 'mechQuality',
      resource: ['work_order', 'platform'],
      component: lazy(() => import('./quality/QualityPage')),
    },
    {
      path: '/veomech/policies',
      title: 'mechPolicies',
      resource: ['work_order', 'platform'],
      component: lazy(() => import('./quality/PoliciesPage')),
    },
    {
      path: '/veomech/notifications',
      title: 'mechNotifications',
      resource: 'platform',
      component: lazy(() => import('./operations/NotificationDiagnosticsPage')),
    },
    {
      path: '/veomech/dictionaries',
      title: 'mechDictionaries',
      resource: 'platform',
      component: lazy(() => import('./operations/DictionariesPage')),
    },
  ],
};
